import { Reflector } from '../reflection';
export function Injectable(metadata) {
  return function (Target) {
    Reflector.addProviderMetadata(Target, metadata);
  };
}

Injectable.getDependencies = function (input) {
  return Reflector.getConstructorDependencies(input);
};